/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { Button, CircularProgress } from '@material-ui/core'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import ButtonLoaderEvent from './../../helpers/custom-events/buttonLoaderEvent'

const LoaderButton = ({ children, ...props }) => {
  const [showLoader, setShowLoader] = useState(false)
  const onEventCatch = (e) => {
    if (props.btnName) {
      if (e.detail.loaderFor === props.btnName) {
        setShowLoader(e?.detail?.showLoader || false)
        return
      }
    } else {
      setShowLoader(e?.detail?.showLoader || false)
    }
  }
  useEffect(() => {
    ButtonLoaderEvent.subscribe(onEventCatch)
    return () => ButtonLoaderEvent.unSubscribe(onEventCatch)
  }, [])
  return (
    <Button {...props} disabled={showLoader || props.disabled}>
      {!showLoader ? children : <CircularProgress size={20} color="var(--color-grey-9)" />}
    </Button>
  )
}

LoaderButton.propTypes = {
  children: PropTypes.element,
  disabled: PropTypes.bool,
  btnName: PropTypes.string,
}
LoaderButton.defaultProps = {
  children: null,
  btnName: '',
  disabled: false,
}

export default LoaderButton
